module.exports = __webpack_public_path__ + "static/media/nilgunbiopic.e4b1b726.jpg";